/* eslint-disable no-undef */
import React, { useEffect, Fragment, FC } from 'react'
import UserInfo from './UserInfo'
import PlaylistTrack from '../pages/playlist/PlaylistTrack'
import PlaylistItem from '../pages/playlist/PlaylistItem'
import { closeModal } from '../../utils'
import { connect } from 'react-redux'
// import { Redirect } from "react-router-dom"
import { getUser, getUserTracks } from '../../store/actions/users'
import { Pie } from 'react-chartjs-2'
import { match, withRouter } from 'react-router-dom'
import { RootState } from '../../store/reducers'
import { Track, Album } from '../../models/track'
import { User } from '../../models/user'
import { getUserAlbums } from '../../store/actions/songs'

interface RRProps<Params extends { username: string } = { username: string }> {
  history: any
  location: any
  match: match<Params>
  staticContext?: any
}

interface Props {
  tracks: Track[]
  albums: Album[]
  getUser: Function
  user: User
  otherUsr: User
  getUserTracks: Function
  getUserAlbums: Function
  sloading: boolean
  userAlbums: Album[]
}

const Profile: FC<Props & RRProps> = ({
  match,
  tracks,
  albums,
  getUser,
  user,
  getUserTracks,
  sloading,
  otherUsr,
  userAlbums,
  getUserAlbums,
}) => {
  const name = match.params.username

  useEffect(() => {
    getUser(name)
    getUserTracks(name)
    getUserAlbums(name)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (document.getElementById('track-modal')) {
    closeModal(`track-modal`)
  }

  if (user) {
    document.getElementsByTagName('title')[0].innerHTML = name
      ? `User: ${name}`
      : user.username
  }

  return (
    <Fragment>
      {user ? (
        <div className="profile app-view-body">
          <div id="profile-head" className="uk-margin-medium-bottom">
            <UserInfo user={name === user.username ? user : otherUsr} />
          </div>
          <hr />

          <div className="profile-body">
            <div className="uk-margin-medium-top">
              <ul
                className="uk-flex-center"
                data-uk-tab="connect: #profile-content"
              >
                <li className="uk-active">
                  <a href="#info">Bio</a>
                </li>
                <li>
                  <a href="#tracks">Tracks</a>
                </li>
                <li>
                  <a href="#albums">Albums</a>
                </li>
                <li>
                  <a href="#stats">Stats</a>
                </li>
              </ul>
              <ul
                id="profile-content"
                className="uk-switcher uk-margin uk-margin-auto uk-width-1-1 uk-width-3-5@m uk-width-4-5@s"
                // data-uk-switcher=" uk-animation: uk-animation-slide-top-medium, uk-animation-slide-right-medium"
              >
                <li>
                  <div id="info">
                    <div className="uk-card">
                      {name ? (
                        <span>{otherUsr && otherUsr.bio}</span>
                      ) : (
                        <span>{user && user.bio}</span>
                      )}
                    </div>
                  </div>
                </li>
                <li>
                  <div id="tracks">
                    {sloading ? (
                      <Fragment>
                        <div data-uk-spinner></div>
                      </Fragment>
                    ) : (
                      <Fragment>
                        {tracks &&
                          tracks.map((track, i) => (
                            <PlaylistTrack track={track} key={i} />
                          ))}
                      </Fragment>
                    )}
                  </div>
                </li>
                <li>
                  <div id="albums">
                    {userAlbums &&
                      userAlbums.map((album, i) => (
                        <PlaylistItem key={i} album={album} />
                      ))}
                  </div>
                </li>
                <li>
                  <div id="stats">
                    <Pie
                      // type="pie"
                      data={{
                        labels: ['Plays', 'Likes', 'Comments'],
                        datasets: [
                          {
                            data: [2300, 230, 23],
                            backgroundColor: ['#F363c4', '#36AFEB', '#BFCE56'],
                            hoverBackgroundColor: [
                              '#FF6384',
                              '#36A2EB',
                              '#FFCE56',
                            ],
                          },
                        ],
                      }}
                    />
                    <div
                      id="myChart"
                      style={{ width: '80%', height: '100%' }}
                    ></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <h4>Oops, we could not find page you were looking for</h4>
      )}
    </Fragment>
  )
}

const mapStateToProps = (state: RootState) => ({
  tracks: state.data.userTracks,
  albums: state.data.albums,
  user: state.auth.user,
  profile: state.auth.user,
  otherUsr: state.auth.otherUsr,
  sloading: state.data.subloading,
  userAlbums: state.data.userAlbums,
})

export default withRouter(
  connect(mapStateToProps, { getUser, getUserTracks, getUserAlbums })(Profile)
)
